import React from 'react'
import ComingSoon from '../../singles/coming-soon/Coming-soon'
export default function Features() {
  return (
    <div>
        <ComingSoon />
    </div>
  )
}
